module.exports = __webpack_public_path__ + "onboarding-success.2835f2a4d59ecb4e6f3ce552018c8fd6.hashedasset.svg";